import JacobSpin from "../assets/videos/HAT-JACOB-SPIN.mp4";
import GurgSpin from "../assets/videos/HAT-GURG-SPIN.mp4";
import CornSpin from "../assets/videos/HAT-CORN-SPIN.mp4";
import Dance from "../assets/videos/HAT-DANCE-VID.mp4";
import FrontHat from "../assets/ym-hat-brn/IMG_1413.jpg";

export const HatsPage = () => {
  return (
    <div
      className="relative flex max-h-[100vh] min-h-[100vh] min-w-[100vw] flex-col items-center justify-center  overflow-y-hidden bg-[red]  "
      style={{
        scrollSnapAlign: "start",
      }}
    >
      {/* <img
          alt=""
          src={FrontHat}
          className="absolute left-1/2 top-[10vh] aspect-square min-h-[100vh] -translate-x-1/2 object-cover opacity-70"
        /> */}
      <video
        autoPlay
        id="video-background"
        muted
        loop
        playsInline
        className="sticky flex aspect-video h-full min-h-[100vh] w-full overflow-x-hidden object-cover lg:top-[-10vh] lg:min-h-[110vh] "
        onLoad={() => {
          console.log("loaded");
        }}
      >
        <source src={Dance} type="video/mp4" />
      </video>
      <div className="absolute flex max-h-[85dvh] min-h-[100dvh] w-[80vw] flex-col items-center justify-center gap-[2.5vh] overflow-y-scroll pt-[5vh] lg:hidden">
        <video
          autoPlay
          id="video-background"
          muted
          loop
          playsInline
          className=" z-[1] flex aspect-video max-h-[25vh] object-contain "
          onLoad={() => {
            console.log("loaded");
          }}
        >
          <source src={JacobSpin} type="video/mp4" />
        </video>
        <video
          autoPlay
          id="video-background"
          muted
          loop
          playsInline
          className=" z-[1] flex aspect-video max-h-[25vh] object-contain "
          onLoad={() => {
            console.log("loaded");
          }}
        >
          <source src={GurgSpin} type="video/mp4" />
        </video>
        <video
          autoPlay
          id="video-background"
          muted
          loop
          playsInline
          className=" z-[1] flex aspect-video max-h-[25vh] object-contain "
          onLoad={() => {
            console.log("loaded");
          }}
        >
          <source src={CornSpin} type="video/mp4" />
        </video>
      </div>
      <div className="absolute hidden flex-col gap-[2.5vh] pt-[10vh] lg:flex lg:items-center lg:justify-center">
        <div className="z-[1] flex w-full justify-center ">
          <video
            autoPlay
            id="video-background"
            muted
            loop
            playsInline
            className=" flex aspect-video  w-[40vw] object-cover "
            onLoad={() => {
              console.log("loaded");
            }}
          >
            <source src={JacobSpin} type="video/mp4" />
          </video>
        </div>
        <div className="z-[1] flex w-full justify-center gap-[10vw] ">
          <video
            autoPlay
            id="video-background"
            muted
            loop
            playsInline
            className=" flex aspect-video  w-[40vw] object-cover "
            onLoad={() => {
              console.log("loaded");
            }}
          >
            <source src={GurgSpin} type="video/mp4" />
          </video>
          <video
            autoPlay
            id="video-background"
            muted
            loop
            playsInline
            className=" flex aspect-video  w-[40vw] object-cover "
            onLoad={() => {
              console.log("loaded");
            }}
          >
            <source src={CornSpin} type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
  );
};
